import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function EcosystemLayout() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <Sidebar />
      <div className="lg:pl-72 min-h-screen flex flex-col">
        <Topbar />
        <main className="flex-1" data-testid="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
